import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Button, Form, Modal} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

import LoadingSpinner from '../widgets/LoadingSpinner';
import ErrorAlert from '../widgets/ErrorAlert';

const CountrySelectModal = ({
                              show,
                              onHide,
                              countries,
                              loading,
                              error,
                              defaultCountryCode,
                              onSelect,
                            }) => {
  const {t} = useTranslation();
  const [selectedCountryCode, setSelectedCountryCode] = useState(defaultCountryCode || '');

  useEffect(() => {
    if (show) {
      setSelectedCountryCode(defaultCountryCode || '');
    }
  }, [defaultCountryCode, show]);

  const handleGoToCountry = () => {
    if (onSelect) {
      onSelect(selectedCountryCode);
    }
  };
  const sortedCountries = [...countries].sort((a, b) => {
    const nameA = t('countries:' + a.isoCode2) || '';
    const nameB = t('countries:' + b.isoCode2) || '';
    return nameA.localeCompare(nameB);
  });

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('auth:modalCountryTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('auth:modalCountryDescription')}</p>
        {loading && (
          <div className="py-3 text-center">
            <LoadingSpinner />
          </div>
        )}
        {!loading && error && (
          <ErrorAlert error={t('auth:msgCountriesUnavailable')} />
        )}
        {!loading && !error && (
          <Form.Group controlId="countrySelector">
            <Form.Label>{t('auth:lblSelectCountry')}</Form.Label>
            <Form.Select
              value={selectedCountryCode}
              onChange={(event) => setSelectedCountryCode(event.target.value)}
              aria-label={t('auth:lblSelectCountry')}
            >
              <option value="">{t('auth:optSelectCountryPlaceholder')}</option>
              {sortedCountries.map((country) => (
                <option key={country.isoCode2} value={country.isoCode2}>
                  {t('countries:' + country.isoCode2)}
                  {country.customsAdministrationName
                    && '  -  ' + country.customsAdministrationName
                  }
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('auth:btnCloseCountrySelector')}
        </Button>
        <Button
          variant="primary"
          onClick={handleGoToCountry}
          disabled={!selectedCountryCode || loading}
        >
          {t('auth:btnGoToCountry')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

CountrySelectModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({
    isoCode2: PropTypes.string,
    customsAdministrationName: PropTypes.string,
  })),
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  defaultCountryCode: PropTypes.string,
  onSelect: PropTypes.func,
};

CountrySelectModal.defaultProps = {
  show: false,
  countries: [],
  loading: false,
  error: '',
  defaultCountryCode: '',
  onSelect: undefined,
};

export default CountrySelectModal;